import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconScheduleSendSvg } from "./IconScheduleSendSvg.mjs";
const IconScheduleSend = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconScheduleSendSvg, ...iconProps });
};
export {
  IconScheduleSend
};
